'use client'

import { ContentForm } from 'features/generator/ContentForm'
import {
	ImagesField,
	qrNameFormConfig,
	socialLinksFormConfig,
	TQrContentFormSection,
	welcomeScreenFormConfig,
} from 'features/generator/contentFormSections'
import { socialInformationFormConfig } from 'features/generator/contentFormSections/SocialInformationForm'
import { qrTypeAtom } from 'features/generator/generatorState'
import { QR_TYPE, TContentFormProps } from 'features/generator/generatorTypes'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { contentDesignFormConfig } from '@/content-from-sections/client'

export const SocialMediaContentForm = (props: TContentFormProps) => {
	const t = useTranslations()
	const qrType = useAtomValue(qrTypeAtom)

	const config = {
		formSectionList: [
			contentDesignFormConfig(t, ImagesField),
			socialInformationFormConfig(t),
			socialLinksFormConfig(t, qrType),
			welcomeScreenFormConfig(t),
			qrNameFormConfig(t),
		] satisfies TQrContentFormSection[],
	}

	return <ContentForm qrType={QR_TYPE.SocialMedia} config={config} {...props} />
}
